import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';

export default function DetailSaldoKas({ closeModal, detailSaldoKas, isOpen }) {
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-800 p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title as="h3" className="text-xl font-bold leading-6 text-slate-900 dark:text-slate-100 mb-4 pb-3 border-b border-slate-100 dark:border-slate-800">
                    Detail Saldo KAS
                  </Dialog.Title>
                  <div className="mt-2">
                    <div className="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden">
                      <div className="p-3 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/80 border-b border-amber-100 dark:border-slate-700">
                        <h2 className="font-semibold text-amber-800 dark:text-amber-500">Detail Transaksi</h2>
                      </div>
                      <div className="flex flex-col bg-white dark:bg-slate-900 divide-y divide-slate-100 dark:divide-slate-800">
                        <div className="py-3 px-4 text-sm font-medium text-slate-600 dark:text-slate-400 flex justify-between items-center sm:text-base">
                          Kode Faktur
                          <span className="font-bold text-amber-600 dark:text-amber-500 bg-amber-50 dark:bg-amber-500/10 px-2 py-0.5 rounded-md">{detailSaldoKas.kode_trx}</span>
                        </div>
                        <div className="py-3 px-4 text-sm font-medium text-slate-600 dark:text-slate-400 flex justify-between items-center sm:text-base">
                          Nominal
                          <span className="font-bold text-emerald-600 dark:text-emerald-400">
                            Rp {numberWithCommas(detailSaldoKas.nominal == undefined ? '0' : detailSaldoKas.nominal)}
                          </span>
                        </div>
                        <div className="py-3 px-4 text-sm font-medium text-slate-600 dark:text-slate-400 flex justify-between items-center sm:text-base">
                          Saldo Akhir
                          <span className="font-bold text-slate-800 dark:text-slate-200">
                            Rp {numberWithCommas(detailSaldoKas.saldo_akhir == undefined ? '0' : detailSaldoKas.saldo_akhir)}
                          </span>
                        </div>
                        <div className="py-3 px-4 text-sm font-medium text-slate-600 dark:text-slate-400 flex justify-between items-center sm:text-base">
                          Tanggal Transaksi
                          <span className="font-semibold text-slate-700 dark:text-slate-300">{detailSaldoKas.tanggal}</span>
                        </div>
                        <div className="py-3 px-4 text-sm font-medium text-slate-600 dark:text-slate-400 flex justify-between items-center sm:text-base">
                          Tipe
                          <span className="font-medium bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 px-2 py-0.5 rounded-md">{detailSaldoKas.tipe}</span>
                        </div>
                        <div className="py-3 px-4 text-sm font-medium text-slate-600 dark:text-slate-400 flex justify-between items-start sm:text-base">
                          Keterangan
                          <span className="font-medium text-slate-800 dark:text-slate-200 text-right max-w-[60%]">{detailSaldoKas.keterangan || '-'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 flex justify-end">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-lg border border-transparent bg-slate-100 dark:bg-slate-800 px-5 py-2.5 text-sm font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Tutup
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
